export default __webpack_public_path__ + "pgnv-assets/884b762513e1fc959be3e92fd92cb0a9.png";